module.exports = __webpack_public_path__ + "static/media/wordpress.1eaf11d0.svg";